import type { AnyRouter } from '@tanstack/react-router';

import type { RecordNames } from './types';

const UNNAMED: RecordNames = { recordName: null };

// The names the mounted pages report, per router and pathname (`setRecordName`).
const recordNames = new WeakMap<AnyRouter, Map<string, RecordNames>>();

// A plain name is the record's own name.
export const toRecordNames = (names: string | RecordNames | null): RecordNames =>
  typeof names === 'string' || names === null ? { recordName: names } : names;

export const recordNamesAt = (router: AnyRouter, pathname: string): RecordNames =>
  recordNames.get(router)?.get(pathname) ?? UNNAMED;

export const storeRecordNames = (router: AnyRouter, pathname: string, names: RecordNames): void => {
  const byPathname = recordNames.get(router) ?? new Map<string, RecordNames>();
  byPathname.set(pathname, names);
  recordNames.set(router, byPathname);
};
